import React from 'react';
import ReactModal from 'react-modal';
import './Modal.css';

const sophasExpressLink = 'https://sophasexpress.liaisoncas.com/applicant-ux/#/login';
const sophasLink = 'https://sophas.aspph.org/';

function buildLink(sophasStatus, website, term, organization) {
  if (term.apply_url && term.apply_url !== '') {
    return term.apply_url;
  } else if (sophasStatus === 'sophas_express') {
    return sophasExpressLink;
  } else if (organization.apply_url && organization.apply_url !== '') {
    return organization.apply_url;
  } else if (sophasStatus === 'sophas') {
    return sophasLink;
  } else if (sophasStatus === 'not_sophas') {
    return website;
  }
  return '';
}

function showButtonText(sophasStatus) {
  if (sophasStatus === 'sophas' || sophasStatus === 'sophas_express') {
    return 'START YOUR APPLICATION';
  } else if (sophasStatus === 'not_sophas') {
    return 'LEARN MORE';
  }
  return '';
}

function showHowApply(sophasStatus) {
  if (sophasStatus === 'sophas') {
    return 'SOPHAS';
  } else if (sophasStatus === 'sophas_express') {
    return 'SOPHAS Express';
  } else if (sophasStatus === 'not_sophas') {
    return 'Contact Institution';
  }
  return '';
}

function showGreRequirement(gre) {
  if (gre === '' || gre === null) {
    return 'Contact Institution';
  } else {
    return gre;
  }
}

const Modal = ({ isOpen, programDescription, closeModal }) => (
  <ReactModal className="Modal" isOpen={isOpen}>
    <header className="Modal--header">
      <div className="Modal--title">{programDescription.organization.name}</div>
      <br />
      <div className="Modal--location">
        {programDescription.term.city !== '' &&
          programDescription.term.city !== null &&
          programDescription.term.city}
        {programDescription.term.city !== '' &&
          programDescription.term.city !== null &&
          programDescription.term.state !== '' &&
          programDescription.term.state !== null &&
          programDescription.term.state !== 'International' &&
          `, ${programDescription.term.state}`}

        <p>{programDescription.term.sophas_id || programDescription.term.non_sophas_id}</p>
      </div>
      <button onClick={closeModal}>
        <span>&times;</span>
      </button>
    </header>

    <div className="Modal--body">
      <div className="Modal--info-container">
        <h2 className="Modal--degree-info">{programDescription.degree.name}</h2>
        <span className="Modal--stem-info">
          {programDescription.term.stem_program == 1 && `STEM Designated Program *`}
        </span>
        <div className="Modal--term-info">
          {programDescription.term.start_term} {programDescription.term.start_year}
          {programDescription.term.concentration !== '' &&
            programDescription.term.concentration !== null &&
            ` \u00A0 | \u00A0 ${programDescription.term.concentration}`}
        </div>
        <div className="Modal--term-deadline">
          Deadline: {programDescription.term.deadline_display}
        </div>

        <div className="Modal--info-box container">
          <div className="Modal--info-column">
            <div className="Modal--info-column-header">Applicant Type</div>
            <div className="Modal--info-column-detail">
              {programDescription.term.application_type}
            </div>
          </div>
          <div className="Modal--info-column">
            <div className="Modal--info-column-header">Delivery Method</div>
            <div className="Modal--info-column-detail">{programDescription.term.delivery}</div>
          </div>
          <div className="Modal--info-column">
            <div className="Modal--info-column-header">How To Apply?</div>
            <div className="Modal--info-column-detail">
              {showHowApply(programDescription.term.sophas_status)}
            </div>
          </div>
          <div className="Modal--info-column">
            <div className="Modal--info-column-header">GRE Requirement</div>
            <div className="Modal--info-column-detail">
              {showGreRequirement(programDescription.term.gre_requirement)}
            </div>
          </div>
        </div>
      </div>
      <a
        className="Modal--apply-button"
        target="_blank"
        rel="noopener noreferrer"
        href={buildLink(
          programDescription.term.sophas_status,
          programDescription.organization.website,
          programDescription.term,
          programDescription.organization
        )}
      >
        {showButtonText(programDescription.term.sophas_status)}
      </a>
      <div
        className="Modal--program-description-content"
        dangerouslySetInnerHTML={{ __html: programDescription.term.description }}
      />
      {programDescription.term.description && programDescription.term.description !== '' && (
        <a
          className="Modal--apply-button"
          target="_blank"
          rel="noopener noreferrer"
          href={buildLink(
            programDescription.term.sophas_status,
            programDescription.organization.website,
            programDescription.term,
            programDescription.organization
          )}
        >
          {showButtonText(programDescription.term.sophas_status)}
        </a>
      )}
    </div>
    <div className="Modal--stem-disclaimer">
      {programDescription.term.stem_program == 1 &&
        `* Please contact the institution registrar's office to confirm the program's STEM Designation`}
    </div>
  </ReactModal>
);

export default Modal;
